module.exports = __webpack_public_path__ + "static/media/jack-o-lantern.0ea18897.svg";